import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsList from '../../../components/newsList';

class CenterNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { shopList4 },
        } = this.props;

        return (
            <div className={styles.center_box}>
                <Chip
                    id="225766"
                    type="recommend"
                    title="凰家尚品列表5"
                    groupName="凰家尚品"
                    content={shopList4}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(CenterNewsBox);
